// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_cl-3";
export var contentContainer = "_cl-0";
export var editorContainer = "_cl-1";
export var quillInputForm = "_cl-2";
export var zoneDivider = "_cl-4";